export default __webpack_public_path__ + "static/media/certificate-detail.294c4ee9.png";